/* @flow */
import * as React from 'react';
import Button from 'components/ButtonDeprecated';
import Fieldset from 'components/Fieldset';
import Text from 'components/Text';
import API from 'lib/RemindAPI';
import ToastActions from 'actions/ToastActions';
import Glyph from 'components/Glyph';
import Link from 'components/Link';
import CurrentUser from 'auth/CurrentUser';
import SETTINGS_ROUTES from 'settings/constants/SettingsRouteConstants';

import './styles/AllPIIDownloadSection.scss';

const AllPIIDownloadSection = () => {
  const sendRequestForAllPII = async () => {
    try {
      await API.request('/chats/email_export', 'POST', {});

      ToastActions.showSuccessToast('Email sent');
    } catch (e) {
      ToastActions.showErrorToast(e);
      console.debug(e, e && e.stack);
    }
  };

  return (
    <div>
      <Fieldset legend="Exporting user data">
        <div className="AllPIIDownloadSection">
          <Text element="div">
            Request an email link to all of your data on Remind. The email might take a few minutes
            to arrive.
          </Text>

          <Button
            disabled={!CurrentUser.hasEmail()}
            onClick={sendRequestForAllPII}
            level="secondary">
            Export data
          </Button>

          {!CurrentUser.hasEmail() && (
            <div className="AllPIIDownloadSection-need-email">
              <Glyph
                color="graphite"
                name="explanation-circle"
                size="small"
                className="AllPIIDownloadSection-need-email-icon"
              />
              <Text>
                {"You don't have an email address set, please "}
                <Link to={SETTINGS_ROUTES.NOTIFICATIONS}>add an email address</Link>.
              </Text>
            </div>
          )}
        </div>
      </Fieldset>
    </div>
  );
};

export default AllPIIDownloadSection;
